import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// 🎨 Deterministic color generator (same duty → same color)
const generateColorFromText = (text) => {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 70%, 55%)`;
};

const DutyTypeBarChart = ({ data = [] }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div className="h-full flex items-center justify-center text-sm text-gray-400">
        No data available
      </div>
    );
  }

  const labels = data.map(d => d.duty_type);
  const values = data.map(d => Number(d.total || 0));
  const colors = labels.map(label => generateColorFromText(label));

  return (
    <Bar
      data={{
        labels,
        datasets: [
          {
            label: "Duties",
            data: values,
            backgroundColor: colors,
            barThickness: 24,
            borderRadius: 4,
          },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.label}: ${ctx.raw}`,
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: { precision: 0 },
            grid: { color: "#eef2f7" },
          },
          x: {
            grid: { display: false },
          },
        },
      }}
    />
  );
};

export default DutyTypeBarChart;
